import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, percent } from '../../../../../helpers';
import RenderInput from '../../../../../common/components/render-input';
import Tooltip from '../../../../../common/components/tooltip';
import { formDetails as StepOneFormDetails } from '../step-one';
import { formDetails as StepTwoFormDetails } from '../step-two';
import { formDetails as StepThreeFormDetails } from '../step-three';
import { formDetails as StepFourFormDetails } from '../step-four';
import { formDetails as StepFiveFormDetails } from '../step-five';
import { formDetails as StepSixFormDetails } from '../step-six';
import { formDetails as SummaryFormDetails } from "../summary";
import {Link} from "react-router-dom";

export const formDetails = {
    key: 'assessment',
    title: 'Assessment',
    formName: Routes.ASSESSMENT,
    incomeKey: 'monthlyIncome',
    expensesKey: 'monthlyExpenses',
    differenceKey: 'monthlyDifference',
    summaryKey: 'assessmentSummary'
};

class AssessmentForm extends Component {
    componentDidMount() {
        const {
            props: {
                changeFieldValue,
                income,
                expenses,
                difference,
                summary
            }
        } = this;

        changeFieldValue(formDetails.incomeKey, income);
        changeFieldValue(formDetails.expensesKey, expenses);
        changeFieldValue(formDetails.differenceKey, difference);
        changeFieldValue(formDetails.summaryKey, summary);
    }

    render() {
        const {
            props: {
                income,
                expenses,
                difference,
                summary,
                summaryData
            }
        } = this;

        if (!income) {
            return null;
        }


        const ctaButton = {
            link: 'https://libro.coconutcalendar.com/service',
            label: 'Book A Meeting',
            target: '_blank'
        };

        return (
            <form className={styles.form}>
                <div className={styles.formSection}>
                    <div className={styles.sectionDivider}>
                        <ul className={styles.summaryList}>
                            <li className={styles.label}>
                                <span className={styles.summaryTitle}>{income.title}:</span>
                                <strong className={styles.summaryValue}>${income.total}</strong>
                            </li>
                            {
                                Object.keys(income.values).map(key => (
                                    <li key={key}>
                                        <span className={styles.summaryTitle}>{income.values[key].label}:</span>
                                        <strong className={styles.summaryValue}>${income.values[key].value}</strong>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>

                <div className={styles.formSection}>
                    <div className={styles.sectionDivider}>
                        <ul className={styles.expenseList}>
                            <li className={styles.label}>
                                <span className={styles.expense}>
                                    <span className={styles.summaryTitle}>{expenses.title}:</span>
                                    <strong className={styles.summaryValue}>${expenses.total}</strong>
                                </span>
                            </li>
                            {
                                Object.keys(expenses.fields).map(key => ([
                                    <li key={key} className={styles.expenseItemLabel}>
                                        <span className={styles.expense}>
                                            <span className={styles.summaryTitle}>{expenses.fields[key].title}:</span>
                                            <strong className={styles.summaryValue}>${expenses.fields[key].total}</strong>
                                        </span>
                                        <strong className={expenses.fields[key].overRecommended ? styles.negativePercent : styles.percent}>
                                            <span className={styles.percentValue}>({expenses.fields[key].percent}%)</span>
                                            {
                                                expenses.fields[key].overRecommended &&
                                                <Tooltip content={`You are over the recommended maximum percentage of ${expenses.fields[key].range.high}%`}/>
                                            }
                                        </strong>
                                    </li>,
                                    <ul key={`${key}-summary`} className={`print-only ${styles.expenseSubList}`}>
                                        {
                                            summaryData
                                                .filter(expenseItem => expenseItem.key === key)
                                                .map(expenseItem => (
                                                    Object.keys(expenseItem.fields).map(fieldKey => (
                                                        <li key={`${expenseItem.key}-${fieldKey}`}>
                                                            <span className={styles.expense}>
                                                                <span className={styles.summaryTitle}>{expenseItem.fields[fieldKey].label}:</span>
                                                                <span className={styles.summaryValue}>${expenseItem.values[fieldKey]}</span>
                                                            </span>
                                                        </li>
                                                    ))
                                                ))
                                        }
                                    </ul>
                                ]))
                            }
                        </ul>
                    </div>
                </div>

                <div className={styles.differenceContainer}>
                    <label htmlFor={difference.key} className={styles.label}>{difference.title}</label>
                    <Field
                        name={difference.key}
                        prefix='$'
                        readOnlyValue={difference.total}
                        component={RenderInput}
                    />
                </div>

                <div className={styles.summaryContainer}>
                    <p className={styles.summary}>{summary}</p>
                    <Link
                        to={ctaButton.link}
                        className={styles.ctaButton}
                        title={ctaButton.label}
                        target={ctaButton.target}
                    >
                        {ctaButton.label}
                    </Link>
                </div>
            </form>
        );
    }
}

AssessmentForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false
})(AssessmentForm);

const StepOneForm = formValueSelector(StepOneFormDetails.formName);
const StepOneFormValues = getFormValues(StepOneFormDetails.formName);
const StepTwoForm = formValueSelector(StepTwoFormDetails.formName);
const StepThreeForm = formValueSelector(StepThreeFormDetails.formName);
const StepFourForm = formValueSelector(StepFourFormDetails.formName);
const StepFiveForm = formValueSelector(StepFiveFormDetails.formName);
const StepSixForm = formValueSelector(StepSixFormDetails.formName);
const SummaryFormValues = getFormValues(SummaryFormDetails.formName);

const mapStateToProps = (state) => {
    if (!StepOneForm(state, StepOneFormDetails.totalKey)) {
        return state;
    }

    const incomeTotal = StepOneForm(state, StepOneFormDetails.totalKey);
    const {
        [StepOneFormDetails.totalKey]: removedIncomeTotal,
        ...incomeValues
    } = StepOneFormValues(state);
    const housingTotal = StepTwoForm(state, StepTwoFormDetails.totalKey);
    const transportationTotal = StepThreeForm(state, StepThreeFormDetails.totalKey);
    const debtTotal = StepFourForm(state, StepFourFormDetails.totalKey);
    const livingTotal = StepFiveForm(state, StepFiveFormDetails.totalKey);
    const savingsTotal = StepSixForm(state, StepSixFormDetails.totalKey);
    const summaryData = SummaryFormValues(state);

    const expensesTotal = housingTotal + transportationTotal + debtTotal + livingTotal + savingsTotal;
    const differenceTotal = incomeTotal - expensesTotal;

    const income = {
        ...StepOneFormDetails,
        key: formDetails.incomeKey,
        title: 'Your Monthly Income',
        total: numberWithCommas(incomeTotal),
        values: Object.keys(StepOneFormDetails.fields).reduce((obj, val) => ({
            ...obj,
            [val]: {
                label: StepOneFormDetails.fields[val].label,
                value: numberWithCommas(incomeValues[val])
            }
        }), {}),
    };

    const expenses = {
        key: formDetails.expensesKey,
        title: 'Your Monthly Expenses',
        total: numberWithCommas(expensesTotal),
        fields: {
            [StepTwoFormDetails.key]: {
                ...StepTwoFormDetails,
                total: numberWithCommas(housingTotal),
                percent: percent(housingTotal, incomeTotal),
                overRecommended: percent(housingTotal, incomeTotal) > StepTwoFormDetails.range.high
            },
            [StepThreeFormDetails.key]: {
                ...StepThreeFormDetails,
                total: numberWithCommas(transportationTotal),
                percent: percent(transportationTotal, incomeTotal),
                overRecommended: percent(transportationTotal, incomeTotal) > StepThreeFormDetails.range.high
            },
            [StepFourFormDetails.key]: {
                ...StepFourFormDetails,
                total: numberWithCommas(debtTotal),
                percent: percent(debtTotal, incomeTotal),
                overRecommended: percent(debtTotal, incomeTotal) > StepFourFormDetails.range.high
            },
            [StepFiveFormDetails.key]: {
                ...StepFiveFormDetails,
                total: numberWithCommas(livingTotal),
                percent: percent(livingTotal, incomeTotal),
                overRecommended: percent(livingTotal, incomeTotal) > StepFiveFormDetails.range.high
            },
            [StepSixFormDetails.key]: {
                ...StepSixFormDetails,
                total: numberWithCommas(savingsTotal),
                percent: percent(savingsTotal, incomeTotal),
                overRecommended: false
            }
        }
    };

    const difference = {
        key: formDetails.differenceKey,
        title: `Your Monthly ${differenceTotal >= 0 ? 'Surplus' : 'Shortfall'}`,
        total: numberWithCommas(differenceTotal),
    };

    const summary = differenceTotal >= 0 ?
        <span>Good news! In the next 12 months you will have a surplus of <strong>${numberWithCommas((differenceTotal * 12))}</strong> if you don't spend your extra money.</span>
        :
        <span>In the next 12 months you will have a shortfall of <strong className={styles.redText}>${numberWithCommas((differenceTotal * 12))}</strong> in your account.</span>;

    return {
        income,
        expenses,
        difference,
        summary,
        summaryData: summaryData[SummaryFormDetails.summaryFieldsKey]
    }
};

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AssessmentForm));
